import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';

import scroll from 'helpers/scroll';
import toastr from 'helpers/toastr';
import cm from 'helpers/commons';
import { safeLocationHref } from 'helpers/pathValidator';
import Infinite from 'react-infinite';

import { Commons } from 'components';

const propTypes = {};

const defaultProps = {};

class DormantStaffList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elements: [],
      headers: [
        { header: '', width: 56, isChecked: true, className: 'allCheckbox' },
        { header: 'ID', width: 150 },
        { header: '이름', width: 150 },
        { header: '권한', width: 150 },
        { header: '사용자 상태', width: 150 },
        { header: '가입일', width: '100vw' }
      ],
      heightIdx: 0,
      containerHeight: 620,
      employeeAuth: cm.authGroupSet('employee'),
      isInfiniteLoading: true
    };
  }

  componentDidMount() {
    const infoHeight = document.querySelector('.info-box').offsetHeight;
    this.setState({
      containerHeight: infoHeight - 200
    });
  }

  componentWillReceiveProps(nextProps) {
    const { staffCheckedData: nCheckData } = nextProps;
    const { staffCheckedData } = this.props;

    if (nCheckData === staffCheckedData) {
      this.scrollEvent(nextProps.staffList);
    }
  }

  componentDidUpdate(nextProps) {
    this.scrollHandler();
  }

  scrollEvent = (staffList) => {
    if (staffList && staffList.data.dormantUsers) {
      const { dormantUsers } = staffList.data;
      this.setState({
        elements: this.buildElements(0, 100, dormantUsers),
        isInfiniteLoading: false
      });
    } else {
      this.setState({ elements: [] });
    }
  };

  handleInfiniteLoad = async () => {
    const { staffList } = this.props;
    const { elements, heightIdx, containerHeight } = this.state;
    const item = staffList ? staffList.data.paging : null;

    const that = this;
    const elemLength = elements.length;
    const itemLength = item ? item.totalCount : 0;
    const infiniteParm = scroll.event(item, elements, containerHeight, heightIdx, elemLength);
    if (elemLength && elemLength < itemLength) {
      const params = {
        orgCode: this.props.params.orgCode,
        groupid: this.props.params.groupid
      };

      if (this.props.params) {
        params.keyword = this.props.params.keyword;
      }

      this.setState({
        isInfiniteLoading: true,
        heightIdx: heightIdx + containerHeight
      });

      const data = this.buildElements(elemLength, elemLength + 100, staffList.data.dormantUsers, false);

      setTimeout(() => {
        that.setState({
          elements: that.state.elements.concat(data),
          heightIdx: infiniteParm.heightIdx,
          isInfiniteLoading: false
        });
      }, 500);
    } else {
      this.setState({
        // isInfiniteLoading : false
      });
    }
  };

  elementInfiniteLoad = () => {
    const { staffList } = this.props;
    let dom = <Commons.LoadingBar />;
    if (!staffList) {
      dom = null;
    } else if (!staffList.data.dormantUsers) {
      dom = null;
    }
    return dom;
  };

  buildElements = (start, end, item) => {
    try {
      const elements = [];
      if (item) {
        const user = item;
        for (let i = start; i < end; i++) {
          const temp = this.listItem(user[i]);
          if (temp) {
            elements.push(temp);
          }
        }
      }
      return elements;
    } catch (e) {
      console.log('###### e : ', e);
    }
  };

  listItem = (item) => {
    const { staffChecked } = this.props;
    const { headers } = this.state;

    let result = null;
    if (item) {
      const styles = [];
      const lastItemIdx = headers.length - 1;
      headers.forEach((headerItem, index) => {
        styles.push({
          flex: index !== lastItemIdx ? `${headerItem.width} 0 auto` : `1 0 auto`,
          width: headerItem.width,
          maxWidth: headerItem.width,
          padding: '10px 0'
        });
      });
      result = (
        <div className="rt-tr -odd" key={item.id} onClick={(e) => this.detClick(e, item)}>
          <div className="rt-td" style={styles[0]}>
            <div className="checkbox pure">
              <label>
                <input
                  type="checkbox"
                  id={item.id}
                  name={item.name}
                  data-status={item.status}
                  className={`staff-checkbox ${item.signId}`}
                  value="on"
                  onClick={(e) => staffChecked(e, item, null)}
                />
                <span />
              </label>
            </div>
          </div>
          <div className="rt-td" style={styles[1]}>
            {item.signId}
          </div>
          <div className="rt-td" style={styles[2]}>
            {item.name}
          </div>
          <div className="rt-td" style={styles[3]}>
            {cm.newTypeName(item.grade)}
          </div>
          <div className="rt-td" style={styles[4]}>
            {cm.gradeTypeName(item.status)}
          </div>
          <div className="rt-td" style={styles[5]}>
            {cm.yyyyMMdd(new Date(item.regDate))}
          </div>
        </div>
      );
      return result;
    }
    return null;
  };

  detClick = (e, item) => {
    // e.preventDefault();
    const { employeeAuth } = this.state;
    const { className } = e.target;

    if (className !== 'rt-td') return;

    if (employeeAuth.all || employeeAuth.update) {
      safeLocationHref(`/main/staffInfo/dormant/${item.id}`);
    } else {
      toastr('top-right', 'warning', '사용자 수정권한이 없습니다.');
    }
  };

  scrollHandler = (e) => {
    const { staffCheckedData } = this.props;
    if (staffCheckedData.length !== 0) {
      staffCheckedData.forEach((data) => {
        $(`#${data.id}`).prop('checked', true);
      });
    }
  };

  tBodyFunc = (state) => {
    const { elements, containerHeight, isInfiniteLoading } = this.state;
    return (
      <div className="rt-tbody" style={state.style}>
        <div className="rt-tr-group">
          <Infinite
            className="infinite-scroll"
            elementHeight={43}
            containerHeight={containerHeight}
            infiniteLoadBeginEdgeOffset={containerHeight - 50}
            onInfiniteLoad={this.handleInfiniteLoad}
            loadingSpinnerDelegate={this.elementInfiniteLoad()}
            isInfiniteLoading={isInfiniteLoading}
            handleScroll={this.scrollHandler}
          >
            {elements}
          </Infinite>
        </div>
      </div>
    );
  };

  noDataProps = (state) => {
    const { staffList } = this.props;
    let dom = <div className="rt-noData">검색 결과가 없습니다.</div>;
    if (staffList && staffList.data.dormantUsers) {
      dom = <div className="rt-noData" />;
    }

    return dom;
  };

  render() {
    const { staffChecked } = this.props;
    const { headers, noDataText } = this.state;
    const fn = { fnChecked: staffChecked, move: null };

    // let tooltipArray = cm.tooltipHeader(4, null);
    const columns = scroll.header(headers, fn);

    return (
      <ReactTable
        className="react-table"
        noDataText={noDataText || '검색 결과가 없습니다.'}
        columns={columns}
        sortable={false}
        resizable={false}
        showPagination={false}
        TbodyComponent={this.tBodyFunc}
        NoDataComponent={this.noDataProps}
        style={{ height: 'calc(100% - 40px)' }}
      />
    );
  }
}

DormantStaffList.propTypes = propTypes;
DormantStaffList.defaultProps = defaultProps;

export default connect((state) => ({
  staffList: state.commons.dormant
}))(DormantStaffList);

// export default DormantStaffList;
